// extracted by mini-css-extract-plugin
export default {"main":"a2bec2ec5f b690b7d6ab ee38dffd5c _07002264b6","title":"_1394777202"};